var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.292893 7.23772C-0.0976311 7.62824 -0.0976311 8.26141 0.292893 8.65193L6.65685 15.0159C7.04738 15.4064 7.68054 15.4064 8.07107 15.0159C8.46159 14.6254 8.46159 13.9922 8.07107 13.6017L2.41421 7.94482L8.07107 2.28797C8.46159 1.89745 8.46159 1.26428 8.07107 0.873756C7.68054 0.483232 7.04738 0.483232 6.65685 0.873756L0.292893 7.23772Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/ChevronLeft.d7728016ee6cc438a2238cce966e661e.svg";
export { ForwardRef as ReactComponent };